module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("\n    Web front-end for Fly-poll "), _c('a', {
    attrs: {
      "href": "https://github.com/rhiokim/fly-poll",
      "target": "_blank"
    }
  }, [_vm._v("GitHub Polls")]), _vm._v(".\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "linkset"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/rhiokim/fly-poll-web",
      "target": "_blank"
    }
  }, [_vm._v("GitHub")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/rhiokim",
      "target": "_blank"
    }
  }, [_vm._v("@rhiokim")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e0390e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Footer.vue
// module id = 263
// module chunks = 1